export function calculateMaxDate(): Date {
  const today = new Date();
  let businessDaysAdded = 0;
  const currentDate = new Date(today);

  while (businessDaysAdded < 45) {
    currentDate.setDate(currentDate.getDate() + 1);
    const dayOfWeek = currentDate.getDay();

    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      businessDaysAdded++;
    }
  }

  return currentDate;
}
